// extracted by mini-css-extract-plugin
export var loadingSpinner = "m_8";
export var loadingText = "m_bb";
export var spin = "m_9";